import axios from "axios";
import { Dispatch } from "redux";
import baseUrl from "../../../Url";
import { setupInterceptorsTo } from "../../Authentication/Interceptors";
import {
  LogOutActionTypes,
  GET_PATIENT_TEAM_FAIL,
  GET_PATIENT_TEAM_LOADING,
  GET_PATIENT_TEAM_SUCCESS,
} from "./ActionTypes";
import { GetPatientTeamReq, GetPatientTeamResponse } from "./Model";
import { headers } from "../../../components/Utility";

export const getPatientTeam = (payload: GetPatientTeamReq) => {
  return function (dispatch: Dispatch<LogOutActionTypes>) {
    dispatch({
      type: GET_PATIENT_TEAM_LOADING,
    });
    setupInterceptorsTo(axios)
      .post(
        baseUrl.baseUrl + `/patientapp/api/patientTeam/get_patientTeam_request`,
        payload,
        {
          headers: headers,
        }
      )
      .then((res) => {
        dispatch({
          type: GET_PATIENT_TEAM_SUCCESS,
          payload: res.data,
          errRes: "",
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_PATIENT_TEAM_FAIL,
          payload: {} as GetPatientTeamResponse,
          errRes: error.response.data.message,
        });
      });
  };
};
